import React, { useEffect, useState } from 'react'
import { WishListProductCard } from './WishListProductCard'
import { useAppDispatch, useAppSelector } from '../../../State/Store'
import { getWishlistByUserId } from '../../../State/customer/WishlistSlice'
import { fetchProductById } from './../../../State/customer/ProductSlice';
import { Alert } from '@mui/material';
import { AddItemRequest, addCartItemToCart } from '../../../State/customer/CartSlice';

export const WishList = () => {
  const dispatch = useAppDispatch()
  const wishlist= useAppSelector(store=>store.wishlist.wishlist)
  const userId   = useAppSelector(s => s.auth.user?.id);
  const loading = useAppSelector(store=>store.wishlist.loading)
  const [addStatus, setAddStatus] = useState<
  "idle" | "loading" | "success" | "error"
>("idle");
const [addError, setAddError] = useState<string | null>(null);
  useEffect(() => { 
  
    if(userId){dispatch(getWishlistByUserId()).unwrap()}
   
   },[dispatch,userId])


  
  const handleAddToCart =async (payload:AddItemRequest) => { 
   try {
    setAddStatus("loading");
    setAddError(null);
  await  dispatch(addCartItemToCart(payload))
  setAddStatus("success");
  setTimeout(() => setAddStatus("idle"), 1800);
   } catch (error:any) {
    setAddStatus("error");
    setAddError(error.message ?? "Something went wrong");
   }
   }

   console.log("wishlist",wishlist);
  return (
    <div className='h-[85vh] p-5 lg:p-20'>
       <div className="">
        {addStatus === "success"&&(
          <Alert
            className="fixed top-[5rem] right-[20vw] z-50 shadow-lg max-w-sm"
            severity="success"
          >
            Added to Cart.
          </Alert>
        )}

        {/* Error */}
        {addStatus === "error" && (
          <Alert
            className="fixed top-[5rem] right-[20vw] z-50 shadow-lg max-w-sm"
            severity="error"
            onClose={() => setAddStatus("idle")}
          >
            {addError}
          </Alert>
        )}
      </div>
        <section>
            <h1 className='text-center text-4xl text-gray-600'><strong>My Wish List</strong> </h1>
            <div className="pt-10 flex flex-wrap gap-5 space-x-5">
                { wishlist?.productDetailResponses?.map((item)=><WishListProductCard handleAddToCart={handleAddToCart} key={item.id} item={item} id={wishlist?.id ?? null} />)}
            </div>
        </section>
    </div>
  )
}
